import type {SxProp} from '@primer/react'

import {ActivityHeader} from './ActivityHeader'
import {CommentActions, type CommentActionsProps} from './CommentActions'

type CommentHeaderProps = CommentActionsProps & {
  avatarUrl: string
  userAvatar?: JSX.Element
  additionalHeaderMessage?: string
  viewerDidAuthor?: boolean
  commentSubjectAuthorLogin?: string
  hideActions?: boolean
  isReply?: boolean
  commentAuthorType?: string
  headingProps?: {
    as: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'
  }
} & SxProp

export function CommentHeader({hideActions, ...props}: CommentHeaderProps) {
  return <ActivityHeader {...props} actions={hideActions ? undefined : <CommentActions {...props} />} />
}

try{ CommentHeader.displayName ||= 'CommentHeader' } catch {}